module.exports = __webpack_public_path__ + "img/blank-comic-book_B09919GXRB.2202e90a.jpg";